import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Projects from "./pages/Projects";
import NotFound from "./pages/NotFound";
import { useMemo } from "react";
import { useWebVitals } from "@/hooks/useWebVitals";

// Optimize QueryClient with better defaults for performance
const createOptimizedQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      // Reduce network load by caching aggressively
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (previously cacheTime)
      retry: 1,
    },
    mutations: {
      retry: 1,
    },
  },
});

const App = () => {
  // Memoize queryClient to prevent recreation on re-renders
  const queryClient = useMemo(() => createOptimizedQueryClient(), []);

  // Monitor Web Vitals for performance optimization
  useWebVitals();

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/projects" element={<Projects />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
